export default __webpack_public_path__ + "static/media/image2.e35da043.jpg";